import "core-js/stable";
import "regenerator-runtime/runtime";
import "swiper/css/swiper.css";
import "animate.css";
// import "@/assets/css/quill.bubble.css";
import "@/assets/css/quill.core.css";
import "@/assets/css/quill.snow.css";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";

import mixins from "@/mixins/mixins.js";
import * as Api from "@/api/index";
import * as Tool from "@/utils/ruoyi";
import Vue from "vue";
import i18n from '@/i18n/index.js';
import store from "./store";
import App from "./App.vue";
import router from "./router";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
//引入主体（页面初始化显示）

//一个个link对象 - 分类
import Header from "@/components/HeaderVue.vue";
import Footer from "@/components/FooterVue.vue";
import Service from "@/components/ServiceVue.vue";
import ButtonVue from "@/components/ButtonVue.vue";
import TitleMore from "@/components/TitleMore.vue";
import CountTo from "vue-count-to";
import vClickOutside from 'v-click-outside'

Vue.use(vClickOutside)

//注册全局头部、底部组件
Vue.component("HeaderVue", Header);
Vue.component("FooterVue", Footer);
Vue.component("ServiceVue", Service);
Vue.component("ButtonVue", ButtonVue);
Vue.component("CountTo", CountTo);
Vue.component("TitleMore", TitleMore);
// eslint-disable-next-line vue/multi-word-component-names
Vue.component("Swiper", Swiper);
// eslint-disable-next-line vue/no-unused-components
Vue.component("SwiperSlide", SwiperSlide);

import vuetify from "./plugins/vuetify";



Vue.mixin(mixins);
Vue.config.productionTip = false;
Vue.prototype.Api = Api;
Vue.prototype.Tool = Tool;
Vue.prototype.$Bus = new Vue()

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
